import { forwardRef } from "react";
import { Header } from "./Header";
import { FeedbackButton } from "./FeedbackButton";

interface MainLayoutProps {
  children: React.ReactNode;
}

export const MainLayout = forwardRef<HTMLDivElement, MainLayoutProps>(({ children }, ref) => {
  return (
    <div ref={ref} className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 pt-16">
        {/* Background glow effects */}
        <div className="fixed inset-0 overflow-hidden pointer-events-none">
          <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-primary/10 rounded-full blur-3xl animate-pulse-glow" />
          <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-accent/10 rounded-full blur-3xl animate-pulse-glow" style={{ animationDelay: '1s' }} />
        </div>
        <div className="relative z-10">
          {children}
        </div>
      </main>
      <FeedbackButton />
    </div>
  );
});

MainLayout.displayName = "MainLayout";
